import { memo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { BzHeading } from '../../../components';

const BenchmarkPerformance = () => {
    return (<>
        <Container fluid className='p-0'>
            <Row className='g-0 pb-4'>
                <Col>
                    <BzHeading className='font-medium font-size5 color-text'>Benchmark Performance</BzHeading>
                </Col>
            </Row>
        </Container>
    </>);
};

export default memo(BenchmarkPerformance);